import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getStyleValue(width) {
    if (typeof width === 'number' && Number.isNaN(width)) {
        // If it is nan, return undefined.
        return undefined;
    }
    if (typeof width === 'string') {
        if (width.endsWith('%')) {
            return width;
        }
        else if (width.endsWith('px')) {
            return Number(width.replace('px', ''));
        }
        else if (!Number.isNaN(Number(width))) {
            return Number(width);
        }
        console.log(`Unknown width ${width} in getImageWidth`);
        return undefined;
    }
    return width;
}
function alignToMargin(align) {
    switch (align) {
        case 'left':
            return { marginRight: 'auto' };
        case 'right':
            return { marginLeft: 'auto' };
        case 'center':
            return { margin: '0 auto' };
        default:
            return {};
    }
}
function Video({ src, urlSource, align = 'center', width, height, }) {
    return (_jsx("video", { style: Object.assign({ width: getStyleValue(width), height: getStyleValue(height) }, alignToMargin(align)), src: src, "data-canonical-url": urlSource, autoPlay: true, 
        // For autoplay, the element needs to be muted to actually start!
        muted: true, "webkit-playsinline": "true", playsInline: true, loop: true }));
}
function Picture({ src, srcOptimized, urlSource, align = 'center', alt, width, height, }) {
    if (src.endsWith('.mp4') || (urlSource === null || urlSource === void 0 ? void 0 : urlSource.endsWith('.mp4'))) {
        return _jsx(Video, { width: width, height: height, align: align, src: src, urlSource: urlSource });
    }
    const image = (_jsx("img", { style: Object.assign({ width: getStyleValue(width), height: getStyleValue(height) }, alignToMargin(align)), src: src, alt: alt, "data-canonical-url": urlSource }));
    if (!srcOptimized)
        return image;
    return (_jsxs("picture", { children: [_jsx("source", { srcSet: srcOptimized, type: "image/webp" }), image] }));
}
export const Image = ({ node }) => {
    return (_jsx(Picture, { src: node.url, srcOptimized: node.urlOptimized, alt: node.alt || node.title, width: node.width || undefined, height: node.height || undefined, align: node.align, 
        // Note that sourceUrl is for backwards compatibility
        urlSource: node.urlSource || node.sourceUrl }));
};
const IMAGE_RENDERERS = {
    image: Image,
};
export default IMAGE_RENDERERS;
